import React from 'react';

type Status = 'approved' | 'adjusted' | 'rejected';

const STATUS_COLOURS: Record<Status, string> = {
  approved: 'bg-dark',
  adjusted: 'bg-warning',
  rejected: 'bg-danger',
};

interface ComponentProps {
  status: Status;
}

const color = (status: ComponentProps['status']) => STATUS_COLOURS[status] ?? 'bg-secondary';

const StatusTag: React.FC<ComponentProps> = ({ status }) => {
  return (
    <span className={`badge ${color(status)} ms-3`} style={{ padding: '6px 10px' }}>
      {status}
    </span>
  );
};

export default StatusTag;
